export { default as ParagraphText } from './paragraph-text';
